import React from 'react'

const IconFrame = ({ children }) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <rect width="48" height="48" rx="8" fill="#20845E" />
    {children}
  </svg>
)

export const DistrictLibraryModerateIcon = () => (
  <IconFrame>
    <mask
      id="educationJoyrideDistrictMask"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="12"
      y="12"
      width="24"
      height="24"
    >
      <rect x="12" y="12" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#educationJoyrideDistrictMask)">
      <path
        d="M22 31C21.7167 31 21.4792 30.9042 21.2875 30.7125C21.0958 30.5208 21 30.2833 21 30C21 29.7167 21.0958 29.4792 21.2875 29.2875C21.4792 29.0958 21.7167 29 22 29H32C32.2833 29 32.5208 29.0958 32.7125 29.2875C32.9042 29.4792 33 29.7167 33 30C33 30.2833 32.9042 30.5208 32.7125 30.7125C32.5208 30.9042 32.2833 31 32 31H22ZM22 25C21.7167 25 21.4792 24.9042 21.2875 24.7125C21.0958 24.5208 21 24.2833 21 24C21 23.7167 21.0958 23.4792 21.2875 23.2875C21.4792 23.0958 21.7167 23 22 23H32C32.2833 23 32.5208 23.0958 32.7125 23.2875C32.9042 23.4792 33 23.7167 33 24C33 24.2833 32.9042 24.5208 32.7125 24.7125C32.5208 24.9042 32.2833 25 32 25H22ZM22 19C21.7167 19 21.4792 18.9042 21.2875 18.7125C21.0958 18.5208 21 18.2833 21 18C21 17.7167 21.0958 17.4792 21.2875 17.2875C21.4792 17.0958 21.7167 17 22 17H32C32.2833 17 32.5208 17.0958 32.7125 17.2875C32.9042 17.4792 33 17.7167 33 18C33 18.2833 32.9042 18.5208 32.7125 18.7125C32.5208 18.9042 32.2833 19 32 19H22ZM17 32C16.45 32 15.9792 31.8042 15.5875 31.4125C15.1958 31.0208 15 30.55 15 30C15 29.45 15.1958 28.9792 15.5875 28.5875C15.9792 28.1958 16.45 28 17 28C17.55 28 18.0208 28.1958 18.4125 28.5875C18.8042 28.9792 19 29.45 19 30C19 30.55 18.8042 31.0208 18.4125 31.4125C18.0208 31.8042 17.55 32 17 32ZM17 26C16.45 26 15.9792 25.8042 15.5875 25.4125C15.1958 25.0208 15 24.55 15 24C15 23.45 15.1958 22.9792 15.5875 22.5875C15.9792 22.1958 16.45 22 17 22C17.55 22 18.0208 22.1958 18.4125 22.5875C18.8042 22.9792 19 23.45 19 24C19 24.55 18.8042 25.0208 18.4125 25.4125C18.0208 25.8042 17.55 26 17 26ZM17 20C16.45 20 15.9792 19.8042 15.5875 19.4125C15.1958 19.0208 15 18.55 15 18C15 17.45 15.1958 16.9792 15.5875 16.5875C15.9792 16.1958 16.45 16 17 16C17.55 16 18.0208 16.1958 18.4125 16.5875C18.8042 16.9792 19 17.45 19 18C19 18.55 18.8042 19.0208 18.4125 19.4125C18.0208 19.8042 17.55 20 17 20Z"
        fill="white"
      />
    </g>
  </IconFrame>
)

export const DifferentiatedGroupsModerateIcon = () => (
  <IconFrame>
    <path
      d="M16 25C17.1 25 18 24.1 18 23C18 21.9 17.1 21 16 21C14.9 21 14 21.9 14 23C14 24.1 14.9 25 16 25ZM17.13 26.1C16.76 26.04 16.39 26 16 26C15.01 26 14.07 26.21 13.22 26.58C12.48 26.9 12 27.62 12 28.43V30H16.5V28.39C16.5 27.56 16.73 26.78 17.13 26.1ZM32 25C33.1 25 34 24.1 34 23C34 21.9 33.1 21 32 21C30.9 21 30 21.9 30 23C30 24.1 30.9 25 32 25ZM36 28.43C36 27.62 35.52 26.9 34.78 26.58C33.93 26.21 32.99 26 32 26C31.61 26 31.24 26.04 30.87 26.1C31.27 26.78 31.5 27.56 31.5 28.39V30H36V28.43ZM28.24 25.65C27.07 25.13 25.63 24.75 24 24.75C22.37 24.75 20.93 25.14 19.76 25.65C18.68 26.13 18 27.21 18 28.39V30H30V28.39C30 27.21 29.32 26.13 28.24 25.65ZM20.07 28C20.16 27.77 20.2 27.61 20.98 27.31C21.95 26.93 22.97 26.75 24 26.75C25.03 26.75 26.05 26.93 27.02 27.31C27.79 27.61 27.83 27.77 27.93 28H20.07ZM24 20C24.55 20 25 20.45 25 21C25 21.55 24.55 22 24 22C23.45 22 23 21.55 23 21C23 20.45 23.45 20 24 20ZM24 18C22.34 18 21 19.34 21 21C21 22.66 22.34 24 24 24C25.66 24 27 22.66 27 21C27 19.34 25.66 18 24 18Z"
      fill="white"
    />
  </IconFrame>
)

export const GenAiModerateIcon = () => (
  <IconFrame>
    <path
      d="M28.81 19.94L25.06 16.19L16 25.25V29H19.75L28.81 19.94ZM18 27V26.08L25.06 19.02L25.98 19.94L18.92 27H18Z"
      fill="white"
    />
    <path
      d="M31.71 17.04C32.1 16.65 32.1 16.02 31.71 15.63L29.37 13.29C29.17 13.09 28.92 13 28.66 13C28.41 13 28.15 13.1 27.96 13.29L26.13 15.12L29.88 18.87L31.71 17.04Z"
      fill="white"
    />
    <path d="M34 31H14V35H34V31Z" fill="white" />
  </IconFrame>
)

export const CurriculumModerateIcon = () => (
  <IconFrame>
    <mask
      id="educationJoyrideCurriculumMask"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="12"
      y="12"
      width="24"
      height="24"
    >
      <rect x="12" y="12" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#educationJoyrideCurriculumMask)">
      <path
        d="M22 31C21.7167 31 21.4792 30.9042 21.2875 30.7125C21.0958 30.5208 21 30.2833 21 30C21 29.7167 21.0958 29.4792 21.2875 29.2875C21.4792 29.0958 21.7167 29 22 29H32C32.2833 29 32.5208 29.0958 32.7125 29.2875C32.9042 29.4792 33 29.7167 33 30C33 30.2833 32.9042 30.5208 32.7125 30.7125C32.5208 30.9042 32.2833 31 32 31H22ZM22 25C21.7167 25 21.4792 24.9042 21.2875 24.7125C21.0958 24.5208 21 24.2833 21 24C21 23.7167 21.0958 23.4792 21.2875 23.2875C21.4792 23.0958 21.7167 23 22 23H32C32.2833 23 32.5208 23.0958 32.7125 23.2875C32.9042 23.4792 33 23.7167 33 24C33 24.2833 32.9042 24.5208 32.7125 24.7125C32.5208 24.9042 32.2833 25 32 25H22ZM22 19C21.7167 19 21.4792 18.9042 21.2875 18.7125C21.0958 18.5208 21 18.2833 21 18C21 17.7167 21.0958 17.4792 21.2875 17.2875C21.4792 17.0958 21.7167 17 22 17H32C32.2833 17 32.5208 17.0958 32.7125 17.2875C32.9042 17.4792 33 17.7167 33 18C33 18.2833 32.9042 18.5208 32.7125 18.7125C32.5208 18.9042 32.2833 19 32 19H22ZM17 32C16.45 32 15.9792 31.8042 15.5875 31.4125C15.1958 31.0208 15 30.55 15 30C15 29.45 15.1958 28.9792 15.5875 28.5875C15.9792 28.1958 16.45 28 17 28C17.55 28 18.0208 28.1958 18.4125 28.5875C18.8042 28.9792 19 29.45 19 30C19 30.55 18.8042 31.0208 18.4125 31.4125C18.0208 31.8042 17.55 32 17 32ZM17 26C16.45 26 15.9792 25.8042 15.5875 25.4125C15.1958 25.0208 15 24.55 15 24C15 23.45 15.1958 22.9792 15.5875 22.5875C15.9792 22.1958 16.45 22 17 22C17.55 22 18.0208 22.1958 18.4125 22.5875C18.8042 22.9792 19 23.45 19 24C19 24.55 18.8042 25.0208 18.4125 25.4125C18.0208 25.8042 17.55 26 17 26ZM17 20C16.45 20 15.9792 19.8042 15.5875 19.4125C15.1958 19.0208 15 18.55 15 18C15 17.45 15.1958 16.9792 15.5875 16.5875C15.9792 16.1958 16.45 16 17 16C17.55 16 18.0208 16.1958 18.4125 16.5875C18.8042 16.9792 19 17.45 19 18C19 18.55 18.8042 19.0208 18.4125 19.4125C18.0208 19.8042 17.55 20 17 20Z"
        fill="white"
      />
    </g>
  </IconFrame>
)
